export default __webpack_public_path__ + "assets/TKO close up at night.43345a91.png";